// Спільний обгортач адмінки: перевірка ролі + табова навігація.
// Якщо юзер не ADMIN — рендеримо спрощений екран без редіректа,
// щоб не спамити запитами /me у роутер-циклі.

import { NavLink, Outlet, Link } from 'react-router-dom';
import { useFetch } from '../../lib/useFetch';
import { api } from '../../lib/api';
import { Loader } from '../../components/Loader';
import { ErrorView } from '../../components/ErrorView';

const tabs = [
  { to: '/admin/dashboard', label: '📊 Дашборд' },
  { to: '/admin/questions', label: 'Питання' },
  { to: '/admin/categories', label: 'Категорії' },
  { to: '/admin/users', label: 'Користувачі' },
  { to: '/admin/purchases', label: '💳 Платежі' },
  { to: '/admin/promocodes', label: '🎟 Промокоди' },
  { to: '/admin/quiz', label: '🎲 Опитування' },
  { to: '/admin/feedback', label: '⭐ Фідбек' },
  { to: '/admin/explanations', label: '💡 Пояснення' },
  { to: '/admin/referrals', label: '👥 Реферали' },
  { to: '/admin/broadcast', label: '📢 Розсилка' },
  { to: '/admin/settings', label: '⚙️ Налаштування' },
];

export function AdminLayout() {
  const { data, loading, error, reload } = useFetch(() => api.me(), []);

  if (loading) return <Loader />;
  if (error) return <ErrorView error={error} onRetry={reload} />;
  if (data && data.user.role !== 'ADMIN') {
    return (
      <div className="space-y-3 p-6 text-center">
        <div className="text-4xl">🚫</div>
        <p className="text-tg-text">Доступ лише для адміністраторів.</p>
        <Link to="/" className="btn-primary inline-block">
          На головну
        </Link>
      </div>
    );
  }

  return (
    <>
      <header className="sticky top-0 z-10 border-b border-tg-secondary-bg bg-tg-bg/95 backdrop-blur">
        <div className="px-4 pt-[env(safe-area-inset-top)]">
          <div className="flex items-center justify-between py-3">
            <h1 className="text-lg font-semibold">Адмінка</h1>
            <Link to="/" className="text-sm text-tg-link">
              ← На сайт
            </Link>
          </div>
          <div className="-mx-1 flex gap-1 overflow-x-auto pb-2">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-1.5 text-sm font-medium ${
                    isActive ? 'bg-tg-button text-tg-button-text' : 'bg-tg-secondary-bg text-tg-text'
                  }`
                }
              >
                {t.label}
              </NavLink>
            ))}
          </div>
        </div>
      </header>
      <Outlet />
    </>
  );
}
